<template>
    <page>
        <module>
            <view-list ref="view" work-type="6" selector :view-config="auth('b_fixed_asset_viewmanage')">
                <template #search>
                    <m-search ref="search" :default-data="defaultSearchData">
                        <m-search-item label="资产编号">
                            <c-input name="asset_code"></c-input>
                        </m-search-item>
                        <m-search-item label="资产名称">
                            <c-input name="asset_name"></c-input>
                        </m-search-item>
                        <m-search-item label="当前状态">
                            <c-select name="current_status" :options="assetUseStatusDic" clearable></c-select>
                        </m-search-item>
                        <m-search-item label="所属网点">
                            <c-select name="outlet_id" async @search="searchOutlet"></c-select>
                        </m-search-item>
                        <m-search-item label="资产状态">
                            <c-select name="status" multiple :options="assetStatusDic" clearable></c-select>
                        </m-search-item>
                    </m-search>
                </template>
                <!--资产编号-->
                <template #asset_code="{data}">
                    <c-link @click="globalDialog('fixedAssetDetail', {props: {id: data.id}})">{{data.asset_code}}</c-link>
                </template>
                <template #image_url="{data}">
                    <c-file-list :value="data.image_url" size="mini"></c-file-list>
                </template>
                <template #current_status="{data}">
                    <c-state v-if="data.status==1" dict="assetUseStatusDic" :value="data.current_status"></c-state>
                    <span v-else>-</span>
                </template>

                <template #status="{data}">
                    <c-state  dict="assetStatusDic" :value="data.status"></c-state>
                </template>

                <template #borrow_status="{data}">
                    <c-state dict="borrowStatusDic" :value="data.borrow_status"></c-state>
                </template>

                <template #operate="{data}">
                    <c-button color="main" v-if="auth('b_fixed_asset_edit')" prepend-icon="tf-add" @click="$refs.assetEdit.open()">创建资产档案</c-button>
                    <c-button v-if="auth('b_fixed_asset_dashboard')" prepend-icon="tf-view" @click="window.open('/asset_dashboard', '_blank')">设备看板</c-button>
                    <c-button v-if="auth('b_fixed_asset_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_fixed_asset_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                    <c-button v-if="auth('b_fixed_asset_borrow')" prepend-icon="tf-take-goods" @click="batchBorrowFixedAsset()">批量借用</c-button>
                    <c-button v-if="auth('b_fixed_asset_borrow')" prepend-icon="tf-return-goods" @click="batchReturnFixedAsset()">批量归还</c-button>
                    <c-button v-if="auth('b_fixed_asset_transfer')" prepend-icon="tf-return-goods" @click="batchTransferFixedAsset()">批量转移</c-button>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="220"
                        button-limit="3"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_fixed_asset_view')" icon="tf-view" @click="globalDialog('fixedAssetDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_fixed_asset_borrow')" icon="tf-take-goods" :disabled="(data.borrow_status == 1 || data.current_status !=1)"
                                        @click="batchBorrowFixedAsset(data)">借用</c-table-button>

                        <c-table-button v-if="auth('b_fixed_asset_borrow')" icon="tf-take-goods" :disabled="(data.borrow_status == 0 || data.current_status !=1)"
                                        @click="batchReturnFixedAsset(data)">归还</c-table-button>

                        <c-table-button v-if="auth('b_fixed_asset_transfer')" icon="tf-take-goods" :disabled="(data.borrow_status == 1 || data.current_status !=1)" @click="batchTransferFixedAsset(data)">转移</c-table-button>

                        <c-table-button v-if="auth('b_asset_repair_edit')" :disabled="data.current_status !=1" icon="tf-operate-record" @click="addRepairRecord(data)">维修</c-table-button>

                        <c-table-button v-if="auth('b_fixed_asset_edit')" icon="tf-edit" @click="$refs.assetEdit.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_fixed_asset_edit')" icon="tf-trash" :disabled="data.status !=1 || data.current_status !=1" @click="removeFixedAsset(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--编辑资产信息弹窗-->
            <asset-edit ref="assetEdit" @resolve="$refs.view.$refs.list.update()"></asset-edit>
            <!--资产借用弹窗-->
            <fixed-asset-borrow ref="fixedAssetBorrow" @resolve="$refs.view.$refs.list.update()"></fixed-asset-borrow>
            <!--维修申请弹窗-->
            <asset-repair-record-edit ref="assetRepairRecordEdit" @resolve="$refs.view.$refs.list.update()"></asset-repair-record-edit>
        </module>
    </page>
</template>

<script>
import AssetEdit from "@/pages/asset/fixed_asset_edit.vue";
import {mapState} from "vuex";
import sysuserRoleEdit from "@/pages/system/sysuser_role_edit.vue";
import fixedAssetBorrow from "@/pages/asset/fixed_asset_borrow.vue";
import assetRepairRecordEdit from "@/pages/asset/asset_repair_record_edit.vue";


export default {
    components: {
        sysuserRoleEdit,
        fixedAssetBorrow,
        AssetEdit,
        assetRepairRecordEdit
    },
    computed: {
        // 获取 dictName 选项数据
        ...mapState(['disableEnableDic', 'assetStatusDic', 'assetUseStatusDic','borrowStatusDic']),
    },
    data() {
        return {
            defaultSearchData: {
                'status': []
            }
        }
    },

    methods: {
        /*******搜索网点*****************/
        searchOutlet(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'AFTERSALE_OUTLET',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },
        /****资产借用****/
        batchBorrowFixedAsset(data){
            var ids = [];
            var asset_names = [];
            var flag = true;
            if(data){
                ids.push(data.id);
                asset_names.push((data.asset_code||'-')+'|'+data.asset_name+'|'+data.outlet_name);
            }else {
                this.$refs.view.$refs.list.getData('selected').forEach(item => {
                    if (item.borrow_status == 1){
                        this.$message({
                            message: '请选择尚未被借用的资产进行借用操作',
                            type: 'warn'
                        });
                        flag = false;
                        return;
                    }
                    if (item.current_status != 1){
                        this.$message({
                            message: '请选择“空闲”的资产进行借用操作',
                            type: 'warn'
                        });
                        flag = false;
                        return;
                    }
                    ids.push(item.id);
                    asset_names.push((item.asset_code||'-')+'|'+item.asset_name+'|'+item.outlet_name);
                });
            }
            if (flag && ids && ids.length > 0){
                var params = {};
                params.type = 1;
                params.asset_ids = ids;
                params.asset_names = asset_names.join("；");
                this.$refs.fixedAssetBorrow.open(params);
            }
        },
        /****资产归还****/
        batchReturnFixedAsset(data){
            var ids = [];
            var flag = true;
            if(data){
                ids.push(data.id);
            }else {
                this.$refs.view.$refs.list.getData('selected').forEach(item => {
                    if (item.borrow_status == 0){
                        this.$message({
                            message: '请选择“借用中”的资产进行归还操作',
                            type: 'warn'
                        });
                        flag = false;
                        return;
                    }
                    if (item.current_status != 1){
                        this.$message({
                            message: '请选择“空闲”的资产进行归还操作',
                            type: 'warn'
                        });
                        flag = false;
                        return;
                    }
                    ids.push(item.id);
                });
            }
            if (flag && ids && ids.length > 0){
                this.$confirm({
                    title: '归还资产',
                    message: '是否确认归还资产？',
                    resolve: () => {
                        this.request({
                            url: '/fixed_asset/return',
                            data: {
                                asset_ids: ids.join(",")
                            },
                            success: () => {
                                this.$message({
                                    message: '资产归还成功',
                                    type: 'success'
                                });
                                this.$refs.view.$refs.list.update();
                            }
                        })
                    }
                })
            }
        },
        /****资产转移****/
        batchTransferFixedAsset(data){
            var ids = [];
            var asset_names = [];
            var flag = true;
            if(data){
                ids.push(data.id);
                asset_names.push((data.asset_code||'')+'|'+data.asset_name+'|'+data.outlet_name);
            }else {
                this.$refs.view.$refs.list.getData('selected').forEach(item => {
                    if (item.borrow_status == 1){
                        this.$message({
                            message: '请选择尚未被借用的资产进行转移操作',
                            type: 'warn'
                        });
                        flag = false;
                        return;
                    }
                    if (item.current_status != 1){
                        this.$message({
                            message: '请选择“空闲”的资产进行转移操作',
                            type: 'warn'
                        });
                        flag = false;
                        return;
                    }
                    ids.push(item.id);
                    asset_names.push((item.asset_code||'-')+'|'+item.asset_name+'|'+item.outlet_name);
                });
            }
            if (flag && ids && ids.length > 0){
                var params = {};
                params.type = 3;
                params.asset_ids = ids;
                params.asset_names = asset_names.join("；");
                this.$refs.fixedAssetBorrow.open(params);
            }
        },

        /******删除资产***********/
        removeFixedAsset(data){
            this.$confirm({
                message:'确认删除资产【'+data.asset_name+'】？删除后不可恢复',
                buttonName: '确定',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/fixed_asset/delete',
                        data: {id:data.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                message:'删除成功',
                                type: 'success'
                            });
                            this.$refs.view.$refs.list.update();
                        }
                    });
                },
                cancel: () => {},
            });
        },
        /******加载[资产维修日志]日志列表**********/
        loadRepairRecordList(data){
            //打开模板选择弹窗
            this.globalDialog('assetRepairRecordListDialog',{
                props: {
                },
                data:data
            });
        },
        /******加载[资产借还日志]日志列表**********/
        loadBorrowRecordList(data){
            //打开模板选择弹窗
            this.globalDialog('assetBorrowRecordListDialog',{
                props: {
                },
                data:data
            });
        },
        /******加载[资产转移日志]日志列表**********/
        loadTransferRecordList(data){
            //打开模板选择弹窗
            this.globalDialog('assetTransferRecordListDialog',{
                props: {
                },
                data:data
            });
        },
        addRepairRecord(data){
            this.$refs.assetRepairRecordEdit.add(data);
        }
    },

    mounted() {
    }
}
</script>

<style lang="stylus" scoped>
.asset-status-tabs {
    margin-bottom: 16px;

    .c-button {
        margin-right: 8px;
    }
}

.asset-code-link {
    color: #1890ff;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
}
</style>
